import * as React from 'react'

import {
  Box,
  BoxProps,
  Button,
  Flex,
  FlexProps,
  HStack,
  Stack,
  useColorModeValue as mode,
  useBoolean,
  useDisclosure,
} from '@chakra-ui/react'

import CategoriesPopover  from './Popover'

type NavItemProps = {
  isActive?: boolean
  href?: string
  label?: string
}

const DesktopNavItem = (props: FlexProps & NavItemProps) => {
    
  const { isActive, label, href = '#', ...rest } = props

  return (
    <Flex
      as="a"
      href={href}
      direction="column"
      justify="center"
      minH="10"
      fontSize="sm"
      fontWeight="medium"
      position="relative"
      aria-current={isActive ? 'page' : undefined}
      color={mode('gray.600', 'gray.400')}
      _activeLink={{
        borderBottomWidth: '2px',
        borderColor: 'currentColor',
        color: mode('blue.500', 'blue.300'),
      }}
      _hover={{
        textDecoration: "underline",
        textDecorationColor: "#3A72C5"
      }}
      {...rest}
    >
      {label}
    </Flex>
  )
}

const MobileNavItem = (props: BoxProps & NavItemProps) => {
  const [flag, setFlag] = useBoolean();
  const { label, href, isActive, ...rest } = props

  const mobileNav = useDisclosure();

  return (

    <Box
      as="a"
      href={href}
      aria-current={isActive ? 'page' : undefined}
      py="2"
      px="3"
      _activeLink={{
        bg: mode('white', 'gray.600'),
        shadow: 'base',
      }}
      {...rest}
    >
      {label}
      </Box>
 
  )
}

const NavItem = {
  Desktop: DesktopNavItem,
  Mobile: MobileNavItem,
}

const menus = [
  // { label: 'Shop By Brand', href: '/shop-by-brand' },
  {label: 'Categories', href: ''},
  { label: 'About Us', href: '/about' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contact Us', href: '/contact-us' },
]

const desktopMenu = [
  // { label: 'Shop By Brand', href: '/shop-by-brand' },
  { label: 'About Us', href: '/about' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contact Us', href: '/contact-us' },
]

const DesktopNavCategoryMenu = () => {
  return (
    <Box
      borderBottomWidth="1px"
      bg="blue.50"
      px="8"
      height="48px"
    >
      <Box maxW="8xl" mx="auto">
        <HStack spacing="6" height="48px">
          <CategoriesPopover></CategoriesPopover>
          {desktopMenu.map((link) => (
            <NavItem.Desktop color="gray.700" key={link.label} {...link} isActive={link.label === 'Men'} />
          ))}
        </HStack>
      </Box>
    </Box>
  )
}

const MobileNavCategoryMenu = () => {
  const mobileNav = useDisclosure();
  return (
    <Box
      width="32%"
      height="100%"
      bg={mode('gray.50', 'gray.700')}
      color={mode('gray.600', 'gray.100')}
      borderEndWidth="1px"
      py="6"
    >
      <Stack spacing="1" width="100%">
        {menus.map((link) => (
          <NavItem.Mobile key={link.label} {...link} isActive={link.label === 'Categories'} />
        ))}
      </Stack>
    </Box>
  )
}

export const NavCategoryMenu = {
  Mobile: MobileNavCategoryMenu,
  Desktop: DesktopNavCategoryMenu,
}